import { getAuth } from "firebase/auth";
import moment from "moment";

import store from "../../redux/store";
import { setUserToken } from "../../redux/slices/userSlice";
import { server } from "../../config/ConfigFirebase";
import { debugLog } from "../../functions";

// Contratos de personas jurídicas (colección contractsLegal). Patrón
// ContractService.js: todo pasa por la Cloud Function handleContractLegal con
// Bearer token; el cliente nunca toca la colección directamente.

const handleContractLegal = async (token, body) => {
  const response = await fetch("https://" + server + ".cloudfunctions.net/handleContractLegal", {
    method: "post",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  if (response.status === 401) {
    const auth = getAuth();
    const token = await auth.currentUser.getIdToken();
    store.dispatch(setUserToken(token));
  }

  return response;
};

// Convierte las fechas serializadas a moment (espejo de getContract).
const withMomentDates = (contract) => ({
  ...contract,
  approvedAt: contract.approvedAt ? moment(new Date(contract.approvedAt)) : null,
  finishedAt: contract.finishedAt ? moment(new Date(contract.finishedAt)) : null,
  startedAt: contract.startedAt ? moment(new Date(contract.startedAt)) : null,
  news: contract.news?.map((n) => ({
    ...n,
    startedAt: n.startedAt ? moment(new Date(n.startedAt)) : null,
    finishedAt: n.finishedAt ? moment(new Date(n.finishedAt)) : null,
  })),
});

export const addContractLegal = async (contract, user) => {
  try {
    const body = { action: "CREATE_CONTRACT_LEGAL", data: contract };
    let response = await handleContractLegal(user.token, body);
    response = await response.json();
    return response.result ? response.body : null;
  } catch (error) {
    debugLog(error);
    return null;
  }
};

export const getContractLegal = async (contractCode, user) => {
  try {
    const body = { action: "GET_CONTRACT_LEGAL", contractCode };
    let response = await handleContractLegal(user.token, body);
    response = await response.json();
    return response.result && response.body ? withMomentDates(response.body) : null;
  } catch (error) {
    debugLog(error);
    return null;
  }
};

// `extras` viaja al nivel raíz del body (p. ej. returnMessage, que el backend
// exige para la devolución pero no persiste).
export const updateContractLegal = async (contractCode, data, user, extras = {}) => {
  try {
    const body = { action: "UPDATE_CONTRACT_LEGAL", contractCode, data, ...extras };
    let response = await handleContractLegal(user.token, body);
    response = await response.json();
    return response.result ? response.body : null;
  } catch (error) {
    debugLog(error);
    return null;
  }
};

// userType: undefined = gestor, 'supervisor' = contratos que supervisa,
// 'contractor' = contratos de su empresa. En ambas vistas el servidor resuelve
// la identidad desde el token (supervisor) o desde users/{uid} (entityNit) y
// post-filtra supervisores efectivos; nunca se manda desde aquí.
export const getContractsLegal = async (user, year, noSelect, userType) => {
  try {
    const body = { action: "GET_CONTRACTS_LEGAL" };
    if (year) body.year = year;
    if (noSelect) body.noSelect = noSelect;
    if (userType) body.userType = userType;
    let response = await handleContractLegal(user.token, body);
    response = await response.json();
    return response.result ? response.body : null;
  } catch (error) {
    debugLog(error);
    return null;
  }
};
